module.exports = "../../app/cells/components/campaigns/widgets/discount_container_cell.rb";